/**
 * @author vishadeep.kapoor
 * OrderSummary constants
 *
 */

// import PAYU_BIZ_IMAGE from '../../assets/images/payment/payu.png';
// import MOBIKWIK_IMAGE from '../../assets/images/payment/mobikwik.png';
import { getBaseUrl } from '../../devUtils/commonUtils';
// import PAYTM_IMAGE from '../../assets/images/payment/paytm.png';


export const DEFAULT_ACTION = '/OrderSummary/DEFAULT_ACTION';
export const SET_CHECKOUT_SUCCESS = '/OrderSummary/SET_CHECKOUT_SUCCESS';
export const GET_ORDER_DETAIL = '/OrderSummary/GET_ORDER_DETAIL';
export const FETCH_PAY_BALANCE_SUCCESS = '/OrderSummary/FETCH_PAY_BALANCE_SUCCESS';
export const GET_CASHFREE_POPUP = '/OrderSummary/GET_CASHFREE_POPUP';
export const SET_CASHFREE_POPUP = '/OrderSummary/SET_CASHFREE_POPUP';
export const SET_GENERATE_OTP = '/OrderSummary/SET_GENERATE_OTP';
export const SET_CONFIRM_OTP = '/OrderSummary/SET_CONFIRM_OTP';

const BASE_URL = getBaseUrl();

export const DEV_PAYMENT_CONSTANTS = {
  mobikwik: {
    resConst: {
      redirect: `${BASE_URL}/mobikwikPayment?transaction_id=%{transaction_id}&success=%{success}&order_no=%{order_no}`,
    },
  },
  payu: {
    resConst: {
      surl: `${BASE_URL}/payuSuccess?transaction_id=%{transaction_id}`,
      furl: `${BASE_URL}/payuFail?transaction_id=%{transaction_id}`,
      secret_code: null,
    },
  },
  gpay: {
    resConst: {
      surl: `${BASE_URL}/payuSuccess?transaction_id=%{transaction_id}`,
      furl: `${BASE_URL}/payuFail?transaction_id=%{transaction_id}`,
      secret_code: null,
    },
  },
  zaggleOption: {
    resConst: {
      redirect: `${BASE_URL}/mobikwikPayment?transaction_id=%{transaction_id}&success=%{success}&order_no=%{order_no}`,
    },
  },
};

export const PAYMENT_MODE = [{
  name: 'payu',
  // image: PAYU_BIZ_IMAGE,
  displayName: 'Debit Card /Credit Card /NetBanking',
},
{
  name: 'mobikwik',
  // image: MOBIKWIK_IMAGE,
  displayName: 'Mobikwik Wallet',
},
{
  name: 'gpay',
  displayName: 'UPI payments',
},
// {
//   name: 'paytm',
//   image: PAYTM_IMAGE,
// },
];
export const GET_PAYMENT_TYPE = (type) => {
  let actionType = '';
  switch (type) {
    case 'gpay':
      actionType = 'Payment Mode - Google Pay';
      break;
    case 'mobikwik':
      actionType = 'Payment Mode - Mobikwik';
      break;
    case 'payu':
      actionType = 'Payment Mode - Debit/Credit Card';
      break;

    default:
      actionType = null;
      break;
  }
  return actionType;
};

export const TRANSACTION_FEE_TOOLTIP = 'This transaction will be subjected to transaction fee of ';
export const BANK_TRANSFER_ALERTS = {
  CONSENT_MESSAGE: '  I verify the accuracy and completeness of my bank account details provided. I authorize the specified amount to be credited to my bank account. I acknowledge that any mistakes in the bank account details are solely my responsibility. I agree to the transaction terms and conditions.',
  TERMS_AND_CONDITIONS: 'Please accept the terms and conditions.',
  ACCOUNT_NUMBERS: 'Account Numbers do not match.',
  ACCOUNT_NUMBERS_LENGTH: 'Account Number length is invalid.',
  BENEFICIARY_NAME_TOOLTIP: `If the provided name matches the registered bank details, the amount will be instantly credited.
   However, if there's a mismatch, manual approval by the Zaggle Team will be necessary to proceed with the transaction,
    which may result in a delay.`,
  BENEFICIARY_NAME_BANK: 'Beneficiary Name At Bank',
};
export const BANKTRANSFER_TOOLTIP = 'I hereby agree that, I allow to verify and authenticate the ownership of my bank accounts when the banking details are provided online.';
export const PAYMENT_KEYS = ['submit_cashfree_info', 'submit_bank_transfer_info'];


// WEBPACK FOOTER //
// client/containers/OrderSummary/constants.js